export function detectTable(text: string) {
  return /^<table[\s\S]*<\/table>/.test(text)
}
